import Segmentation from "./Segmentation.js";

const VTKjs = {
    Segmentation
};

export default VTKjs;
